import { sql, SQL } from 'drizzle-orm';
import { AnyPgColumn } from 'drizzle-orm/pg-core';

export function lower(field: AnyPgColumn): SQL {
  return sql`lower(${field})`;
}
